import { combineReducers } from 'redux';
import rolePermissions from './role-permissions';

const profilesQueueReducer = combineReducers({
  rolePermissions,
});

export default profilesQueueReducer;
